import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { COMMAND_PRIORITY_HIGH, KEY_ENTER_COMMAND } from 'lexical';
import { memo, useEffect } from 'react';

const KeyInterceptPlugin = memo(() => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.registerCommand(
      KEY_ENTER_COMMAND,
      (e) => {
        if (e.shiftKey) {
          return false;
        }
        e.preventDefault();
        return true;
      },
      COMMAND_PRIORITY_HIGH
    );
  }, [editor]);

  return null;
});

KeyInterceptPlugin.displayName = 'KeyInterceptPlugin';

export default KeyInterceptPlugin;
